/* eslint-disable */
import plugin from 'tailwindcss/plugin';

export default plugin(({ addUtilities }) => {
  addUtilities(getWhitespaceUtilities());
  addUtilities(getOverflowUtilities());
  addUtilities(getTypographyUtilities());
  addUtilities(getScrollbarUtilities());
});

const getWhitespaceUtilities = () => {
  return {
    '.whitespace-unset': {
      whiteSpace: 'unset'
    }
  };
};

const getOverflowUtilities = () => {
  return {
    '.overflow-unset': {
      overflow: 'unset'
    }
  };
};

const getTypographyUtilities = () => {
  return {
    // header
    '.typography-header-base': {
      '@apply text-beige-100 font-brown not-italic font-bold': {}
    },
    '.typography-header-xxl': {
      '@apply typography-header-base': {},
      '@apply text-[90px] leading-[1.2] tracking-[-.9px]': {}
    },
    '.typography-header-xl': {
      '@apply typography-header-base': {},
      '@apply text-[60px] leading-[1.3] tracking-[-.6px]': {}
    },
    '.typography-header-l': {
      '@apply typography-header-base': {},
      '@apply text-[45px] leading-[1.3] tracking-[-.45px]': {}
    },
    '.typography-header-m': {
      '@apply typography-header-base': {},
      '@apply text-[36px] leading-[1.4] tracking-[-.36px]': {}
    },
    '.typography-header-s': {
      '@apply typography-header-base': {},
      '@apply text-[28px] leading-[1.4] tracking-[-.28px]': {}
    },
    '.typography-header-xs': {
      '@apply typography-header-base': {},
      '@apply text-[22px] leading-[1.4] tracking-[0px]': {}
    },
    '.typography-header-xxs': {
      '@apply typography-header-base': {},
      '@apply text-[18px] leading-[1.4] tracking-[0px]': {}
    },
    '.typography-header-xxxs': {
      '@apply typography-header-base': {},
      '@apply text-[14px] leading-[1.4] tracking-[0px]': {}
    },
    '.typography-header-outline-base': {
      '@apply text-stroke-beige-100 text-fill-transparent font-brown not-italic font-bold':
        {}
    },
    '.typography-header-outline-xxl': {
      '@apply typography-header-outline-base': {},
      '@apply text-[90px] leading-[1.2] tracking-[-.9px] text-stroke': {}
    },
    '.typography-header-outline-xl': {
      '@apply typography-header-outline-base': {},
      '@apply text-[60px] leading-[1.3] tracking-[-.6px] text-stroke-[.85px]':
        {}
    },
    '.typography-header-outline-l': {
      '@apply typography-header-outline-base': {},
      '@apply text-[45px] leading-[1.3] tracking-[-.45px] text-stroke-[.75px]':
        {}
    },

    // eyebrow
    '.typography-eyebrow-base': {
      '@apply text-beige-100 font-brown not-italic font-bold uppercase': {}
    },
    '.typography-eyebrow-l': {
      '@apply typography-eyebrow-base': {},
      '@apply text-[19px] leading-[1.4] tracking-[3.42px]': {}
    },
    '.typography-eyebrow-m': {
      '@apply typography-eyebrow-base': {},
      '@apply text-[16px] leading-[1.5] tracking-[2.88px]': {}
    },
    '.typography-eyebrow-s': {
      '@apply typography-eyebrow-base': {},
      '@apply text-[13px] leading-[1.5] tracking-[2.34px]': {}
    },
    '.typography-eyebrow-xs': {
      '@apply typography-eyebrow-base': {},
      '@apply text-[10px] leading-[1.6] tracking-[1.8px]': {}
    },

    // body
    '.typography-body-base': {
      '@apply text-beige-100 font-brown not-italic font-normal [&_a]:text-cerulean-400 [&_a:hover]:underline':
        {}
    },
    '.typography-body-xxxl': {
      '@apply typography-body-base': {},
      '@apply text-[35px] leading-[1.5] tracking-[-.35px]': {}
    },
    '.typography-body-xxl': {
      '@apply typography-body-base': {},
      '@apply text-[27px] leading-[1.6] tracking-[-.27px]': {}
    },
    '.typography-body-xl': {
      '@apply typography-body-base': {},
      '@apply text-[23px] leading-[1.6] tracking-[-.23px]': {}
    },
    '.typography-body-l': {
      '@apply typography-body-base': {},
      '@apply text-[19px] leading-[1.7] tracking-[-.19px]': {}
    },
    '.typography-body-m': {
      '@apply typography-body-base': {},
      '@apply text-[16px] leading-[1.7] tracking-[0px]': {}
    },
    '.typography-body-s': {
      '@apply typography-body-base': {},
      '@apply text-[14px] leading-[1.7] tracking-[0px]': {}
    },
    '.typography-body-xs': {
      '@apply typography-body-base': {},
      '@apply text-[12px] leading-[1.7] tracking-[0px]': {}
    },
    '.typography-body-xxs': {
      '@apply typography-body-base': {},
      '@apply text-[10px] leading-[1.7] tracking-[0px]': {}
    },
    '.typography-body-xxxs': {
      '@apply typography-body-base': {},
      '@apply text-[8px] leading-[1.8] tracking-[0px]': {}
    }
  };
};

const getScrollbarUtilities = () => {
  return {
    '.scrollbar-width-none': {
      scrollbarWidth: 'none',
      '-ms-overflow-style': 'none',

      '&::-webkit-scrollbar': {
        '@apply hidden': {}
      }
    }
  };
};
